define(['edge/platform/featuredetection/ApplicationFeatures', 'exports?phoneUtils!libphonenumber'], (ApplicationFeatures, phoneUtils)=> {
    /**
     * Module that returns the current date. Can be replaced with
     * another implementation, for example if you needed to time travel and return
     * a different current date
     */
    return (LocaleService)=> {
        return {
            'isPossibleNumber': (propertyValue, countryCode)=> {
                let returnVal = true;
                let extPos;
                let number;
                if (angular.isDefined(propertyValue) && propertyValue !== null && propertyValue !== '') {
                    if (ApplicationFeatures.hasFeature('phone-validation.libphonenumber')) {
                        extPos = propertyValue.indexOf(' x');
                        number = extPos > 0 ? propertyValue.substring(0, extPos) : propertyValue;
                        number = number.replace(/[-_]/g, '');
                        try {
                            returnVal = phoneUtils.isPossibleNumber(number, countryCode || LocaleService.getConfiguredPhoneRegion());
                        } catch (e) {
                            return false; //Suppress log error message from libphonenumber when number is not valid
                        }
                    }
                }
                return returnVal;
            }
        };
    };
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/util/PhoneUtil.js